import React from "react";

function DoorPrinciples() {
    return (
        <div>
            <h2>Principles of Working in the Private Security Industry</h2>
            <p>
                This module provides an overview of the private security industry, the role of the Security Industry Authority (SIA), and the expectations placed on licensed professionals.
            </p>

            <h3>The Role of the SIA</h3>
            <ul>
                <li>Regulates the private security industry in the UK</li>
                <li>Issues licenses to individuals and approves training providers</li>
                <li>Sets standards for conduct and training</li>
                <li>Enforces compliance and investigates misconduct</li>
            </ul>

            <h3>Licensing and Training</h3>
            <ul>
                <li>Must complete an approved training course</li>
                <li>Hold a valid Emergency First Aid at Work certificate</li>
                <li>Pass identity and criminal background checks</li>
                <li>Renew license every 3 years</li>
            </ul>

            <h3>Professional Standards</h3>
            <ul>
                <li>Act with honesty and integrity</li>
                <li>Respect confidentiality and data protection laws</li>
                <li>Maintain a professional appearance and demeanor</li>
                <li>Follow site-specific policies and procedures</li>
            </ul>

            <h3>⚖️ Legal Responsibilities</h3>
            <ul>
                <li>Understand and comply with the Private Security Industry Act 2001</li>
                <li>Respect human rights and equality legislation</li>
                <li>Use force only when necessary and proportionate</li>
                <li>Report incidents accurately and promptly</li>
            </ul>

            <h3>Working with Others</h3>
            <ul>
                <li>Coordinate with police, emergency services, and venue staff</li>
                <li>Support vulnerable individuals and promote public safety</li>
                <li>De-escalate conflict and maintain calm environments</li>
            </ul>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://www.gov.uk/government/organisations/security-industry-authority" target="_blank" rel="noreferrer">SIA – Official Website</a></li>
                <li><a href="https://www.skillsforsecurity.org.uk/" target="_blank" rel="noreferrer">Skills for Security – Industry Standards</a></li>
                <li><a href="https://www.legislation.gov.uk/ukpga/2001/12/contents" target="_blank" rel="noreferrer">Private Security Industry Act 2001</a></li>
            </ul>
        </div>
    );
}

export default DoorPrinciples;
